import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import LoggerActivations from 'pages/LoggerActivations'

export const Route = createFileRoute('/_auth/_global/logger-activations')({
  beforeLoad: requireGlobalRole(GlobalRoleType.GLOBAL_ADMIN),
  component: LoggerActivations,
})
